import { Injectable } from "@angular/core";
import { BaseServiceExt } from "@providers/BaseServiceExt";
import {
  FreeBetAvailableDepositFb,
  FreeBetAvailableDepositFbFormatted,
  FreeBetData,
} from "@sports-pages/ticket/models";
import { SportsConstants } from "@sports-utils/index";
import { ACTIVO, INACTIVO } from "@sports-utils/sports.constants";
import { Observable, forkJoin, of, switchMap } from "rxjs";

@Injectable({ providedIn: "root" })
export class SportsFreeBetsService extends BaseServiceExt {
  private getActiveVouchers(hideLoader: boolean = true): Observable<any> {
    // On sportsVouchers response, availableDeposit will be empty and data will be a list
    const sportsVouchersUrl: string = `${this.globalVars.SportsMiscUrl}${SportsConstants.GetAccountSportsVouchers}`;
    return this.myGet(sportsVouchersUrl, hideLoader);
  }

  getFreeBets(getOnlyActiveVouchers: boolean = false, hideLoader: boolean = true): Observable<any> {
    const sportsVouchers$ = this.getActiveVouchers(hideLoader);
    if (getOnlyActiveVouchers) {
      return sportsVouchers$;
    }

    // On pendingIssuedBonus response, availableDeposit will be a list and data will be empty
    const getPendingIssuedBonusUrl: string = `${this.globalVars.UrlFreebetBonus}${SportsConstants.GetPendingIssuedBonus}`;
    const pendingIssuedBonus$ = this.myGet(getPendingIssuedBonusUrl, hideLoader);
    // Both responses have a pendingSms and success key
    return forkJoin([pendingIssuedBonus$, sportsVouchers$]).pipe(
      switchMap(([pendingIssuedBonusResponse, sportsVouchersResponse]) => {
        return of({
          availableDepositFbs: pendingIssuedBonusResponse?.availableDepositFbs,
          data: sportsVouchersResponse?.data,
          success: pendingIssuedBonusResponse?.success && sportsVouchersResponse.success,
          pendingSms: pendingIssuedBonusResponse?.pendingSms || sportsVouchersResponse.pendingSms,
          message: pendingIssuedBonusResponse?.message || sportsVouchersResponse.message,
        });
      }),
    );
  }

  formatFb = (value: FreeBetAvailableDepositFb): FreeBetAvailableDepositFbFormatted => {
    //parse  the value properties
    let totalBets = value.DepositAmount * value.ConversionRate;
    totalBets =
      totalBets > value.MaxBets * value.MaxBonusMultiplier ? value.MaxBets * value.MaxBonusMultiplier : totalBets;
    const dateGW =
      this.toDate(value.LastGrossWinUpdate) > this.toDate(value.StartDate)
        ? parseInt(value.LastGrossWinUpdate)
        : 0;
    const now: Date = new Date();
    const strActive: string =
      this.toDate(value.DateLimit) <= now && now >= this.toDate(value.StartDate) ? ACTIVO : INACTIVO;

    const pendingFb = {
      Name: value.PromoName,
      Type: value.PromoType,
      GrossWin: value.GrossWin > 0 ? value.GrossWin : 0,
      AmountFb: value.MaxBets,
      TotalBets: totalBets,
      minOdd: value.MinOdds,
      AmountBets: value.ValidBets,
      pendingAmount: totalBets - value.ValidBets,
      date: new Date(value.DateLimit),
      dateStart: value.StartDate,
      dateGW: dateGW,
      active: strActive,
      PercentDev: value.VoucherMultiplier * 100,
      Url: value.ConditionsUrl !== null ? value.ConditionsUrl : "",
    };

    return pendingFb;
  };

  toDate(str: string): Date {
    return new Date(parseInt(str.slice(6, str.length - 2)));
  }

  splitFbToOnlineAndLocal(preFb: FreeBetAvailableDepositFb[], activeFb: FreeBetData[]) {
    let activeFBOnline = [];
    let activeFBLocal = [];
    let aPendingFBOnline = [];
    let aPendingFBLocal = [];
    if (activeFb !== null) {
      activeFBOnline = activeFb.filter((value) => !value.IsTerminalVoucher);
      activeFBLocal = activeFb.filter((value) => value.IsTerminalVoucher);
    }
    if (preFb !== null) {
      aPendingFBOnline = preFb
        .filter((value) => {
          if (value.PromoType.indexOf("online") !== -1) {
            return true;
          } else {
            return false;
          }
        })
        .map(this.formatFb);

      aPendingFBLocal = preFb
        .filter((value) => {
          if (value.PromoType.indexOf("online") === -1) {
            return true;
          } else {
            return false;
          }
        })
        .map(this.formatFb);
    }
    return { activeFBOnline, activeFBLocal, aPendingFBOnline, aPendingFBLocal };
  }
}
